import cn from './index.module.css'
import { declOfNum } from '@/helpers/declOfNum'
import FieldWrapper from '@pages/Admin/CourseSettings/components/FieldWrapper/FieldWrapper'

const ShowClassValue = ({ value }: { value: number }) => {
  const getPeriodString = (): string => {
    return `${value} ${declOfNum(value, ['месяц', 'месяца', 'месяцев'])}`
  }

  return (
    <div className={cn.wrapper}>
      <FieldWrapper label="Длительность">
        <div className={cn.valueWrapper}>{getPeriodString()}</div>
      </FieldWrapper>
    </div>
  )
}

export default ShowClassValue
